import { JSX } from "react";
import { ApplicationPage } from "../application-page";
import { usePageNavigation } from "../use-page-navigation";
import { createModal } from ".";

export const ModalPage = (props: {
  children: JSX.Element;
  pageId: string;
  pageSize?: "small" | "medium" | "large";
  showEvent?: Function;
  closeEvent?: Function;
}): JSX.Element => {
  const pageNavigation = usePageNavigation();
  const page = ApplicationPage.pageById(props.pageId);
  return (
    <>
      {createModal(
        page.label,
        props.children,
        () =>
          props.closeEvent
            ? props.closeEvent()
            : pageNavigation.backToPrevPage(),
        props.pageSize,
        props.showEvent,
      )}
    </>
  );
};
